import React from "react";
import type { RestaurantRow, Translate } from "../chatbotManagement.types";
import { formatNumber, progressColor, usagePercentage } from "../chatbotManagement.utils";

interface UsageCellProps {
  row: RestaurantRow;
  t: Translate;
}

const UsageCell = ({ row, t }: UsageCellProps): React.ReactElement => {
  const usageWindow = row.weekly_usage || row.usage_windows?.find(({ key }) => key === "weekly");
  if (!usageWindow) return <span>-</span>;

  const percentage = usagePercentage(usageWindow.tokens_used, usageWindow.token_limit);

  return (
    <div style={{ minWidth: 230 }}>
      <div className="d-flex align-items-center mb-1">
        <div className="progress flex-grow-1 mr-2" style={{ height: 9, background: "#ececec" }}>
          <div
            className="progress-bar"
            role="progressbar"
            aria-label={t("admin_chatbot_weekly_usage_for", { restaurant: row.restaurant_name })}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={percentage}
            style={{ width: `${percentage}%`, backgroundColor: progressColor(percentage) }}
          />
        </div>
        <strong>{percentage}%</strong>
      </div>
      <small className="text-muted">
        {formatNumber(usageWindow.tokens_used)} / {formatNumber(usageWindow.token_limit)} tokens ·{" "}
        {t("admin_chatbot_images_count", { count: usageWindow.image_generations_used || 0 })}
      </small>
    </div>
  );
};

export default UsageCell;
